import { type SessionClinicalEntity } from '@/types';
import { type CodeConcept, type CodeSystem } from '@heidi/coding/contracts';
import { atom } from 'jotai';
import { EmbeddingsScreen } from './types';

export const selectedClinicianCodeAtom = atom<SessionClinicalEntity | null>(null);
export const selectedCodeConceptAtom = atom<CodeConcept | null>(null);
export const embeddingsScreenAtom = atom<EmbeddingsScreen>(
  EmbeddingsScreen.EmbeddingsList
);
export const embeddingsDisclaimerModalOpenAtom = atom<{
  isOpen: boolean;
  codesToApprove?: {
    sessionId?: string;
    entityId?: string;
    codeSystem?: CodeSystem;
    code?: string;
  }[];
  sessionId?: string;
}>({
  isOpen: false,
  codesToApprove: undefined,
});

/** Tracks the note's updatedAt timestamp when codes were last regenerated */
export const lastRegeneratedNoteTimestampAtom = atom<string | null>(null);
